import { ScheduleRow } from "entities/weather/model/types";
import { ChartWrapper, Dot, Line, Svg } from "./style";

type PressureChartProps = {
  hours: ScheduleRow["hours"];
  isTablet: boolean;
};

export const PressureChart: React.FC<PressureChartProps> = ({
  hours,
  isTablet,
}) => {
  if (!hours?.length) return null;

  const COL_W = hours.length < 24 ? (isTablet ? 150 + 8 : 210 + 8) : 90 + 8;
  const HEIGHT = 52;

  const pressures = hours
    .map((h) => h.pressureMm)
    .filter((p): p is number => typeof p === "number");

  if (pressures.length === 0) return null;

  const min = Math.min(...pressures);
  const max = Math.max(...pressures);
  const range = max - min || 1;

  const points = hours.map((h, i) => {
    const p = h.pressureMm ?? min;
    const x = i * COL_W + COL_W / 2;
    const y = HEIGHT - ((p - min) / range) * (HEIGHT - 20) - 10;
    return { x, y };
  });

  const path = points
    .map((p, i) => (i === 0 ? `M ${p.x} ${p.y}` : `L ${p.x} ${p.y}`))
    .join(" ");

  return (
    <ChartWrapper>
      <Svg width={points.length * COL_W} height={HEIGHT}>
        <Line d={path} />
        {points.map((p, i) => (
          <Dot key={i} cx={p.x} cy={p.y} />
        ))}
      </Svg>
    </ChartWrapper>
  );
};
